export default [
  { key: "no", label: "ลำดับที่", sortable: true , thStyle:{color:"white",width: "5% !important"}},
  {
    key: "hwBrandName",
    label: "	Brand",
    thStyle:{color:"white"}
  },  
  { key: "hwBrandStatus", label: "สถานะ", sortable: true , thStyle:{color:"white",width: "8% !important", textAlign: "center"}},  
  {
    key: "action",
    label: "จัดการ",
    sortable: false,
    thStyle: { width: "12% !important", textAlign: "center", color:"white" },
  },
];
